<template>
  <div class="message-pane">
    <div class="banner"></div>
    <div class="blog-container">
      <div class="album-item">
        <div class="talks-box">
          <div class="top-title">分类</div>
          <div class="categories-box" v-for="(item,index) in categoriesList" :key="index" @click="goDetailPage(item.classify)"><span class="line-name">{{item.classify}}</span> <span class="line-num">({{item.num}})</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "categories",
  data() {
    return {
      categoriesList:[]
    };
  },
  created() {
    this.$store.commit("footerIshow", true);
  },
  mounted() {
    this.getClassify();
  },
  methods: {
    goDetailPage(value) {
      this.$router.push('/categories/'+value);
    },
    getClassify() {
      this.$axios.get(`/api/classify/search`).then(({data}) => {
        // console.log(data,'datadata');
        if(data.result) {
          this.categoriesList = data.data;
        }else {
          this.$message.error(data.msg);
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
.banner {
  background: url("../../assets/images/categories/bg.jpg") center center / cover no-repeat;
  // position: absolute;
  background-color: #49b1f5 !important;
  // top: -60px;
  // left: 0;
  // right: 0;
  height: 400px;
  animation: header-effect 1s;

  .about-name {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 26px;
  }
}

.blog-container {
  animation: main 1s;
  max-width: 970px;
  padding: 50px 40px;
  margin: 40px auto 140px auto;

  .album-item {
    width: 100%;
    border-radius: 0.5rem;

    .talks-box {
      display: flex;
      flex-direction: column;
      padding: 16px 20px;
      border-radius: 10px;
      background: hsla(0, 0%, 100%, 0.1);
      box-shadow: 0 3px 8px 6px rgb(7 17 27 / 6%);
      transition: all 0.3s ease 0s;

      .top-title {
        text-align: center;
        font-weight: 500;
        font-size: 30px;
        margin-bottom: 30px;
      }

      .categories-box {
        margin: 0 30px 20px 30px;
        color: #4c4948;
        font-size: 15px;
        cursor: pointer;
        display: flex;
        align-items: center;

        .line-num {
          margin-left: 0.5rem;
          font-size: 0.75rem;
          color: #858585;
        }
      }

      .categories-box:hover:before {
        border: 0.2rem solid #ff7242;
      }

      .categories-box:hover .line-name {
        transition: all 0.8s;
        color: #8e8cd8;
      }

      .categories-box::before {
        display: inline-block;
        position: relative;
        left: -0.75rem;
        top: 0.1rem;
        width: 6px;
        height: 6px;
        border: 0.2rem solid #49b1f5;
        border-radius: 50%;
        background: #fff;
        content: "";
        transition-duration: 0.3s;
      }
    }
  }
}
</style>
